import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import styled from 'styled-components'
import { colors } from '~/design'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;

  img {
    width: 100%;
    height: 165px;
    object-fit: cover;
  }

  .text {
    padding: 15px;
  }

  .bottom {
    display: flex;
    justify-content: flex-end;
    padding: 10px 15px 15px;

    a {
      display: flex;
      align-items: center;
      gap: 5px;
      font-weight: bold;
      padding: 2px 8px;
      background: ${colors.sebraeBlue};
      color: #fff;
      border-radius: 10px;
      transition: transform 0.2s ease-in-out;

      &:hover {
        transform: scale(1.05);
      }
    }
  }
`

export default function DashboardGridItemStandardPortfolioReport() {
  return (
    <Wrapper>
      <div>
        <img
          src='https://images.unsplash.com/photo-1711097383282-28097ae16b1d?auto=format&fit=crop&fm=jpg&q=80&w=1200'
          alt='Painel de dados'
        />
        <div className='text'>
          <span>
            Visão inicial dos principais resultados dos portfólios de soluções e seus
            indicadores.
          </span>
        </div>
      </div>
      <div className='bottom'>
        <a href={'/app/report/standard-portfolio-report'}>
          ver mais
          <FontAwesomeIcon icon={faArrowRight} color='#fff' />
        </a>
      </div>
    </Wrapper>
  )
}
